exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".brioche-bg[data-v-38ae8f0d]{display:inline-block;width:100%;height:100%;background-position:center;background-repeat:no-repeat;background-size:contain}\n", ""]);
